import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { apiCaller } from "../../../../services/AxiosInstance";

const CustomCreatableDropdown = ({
  fieldName,
  error,
  values,
  label,
  classes,
  setFieldValue,
  options: dataOptions,
  handleChange,
  parent,
}) => {
  const [options, setOptions] = useState(dataOptions);
  useEffect(() => {
    setOptions(dataOptions);
  }, [dataOptions]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCreate = async () => {
    setIsLoading(true);
    try {
      const res = await apiCaller({
        url: "master/genre",
        method: "post",
        data: {
          name: inputValue,
          category: parent,
        },
      }).then((response) => response?.data);
      const newOption = { label: res.data.name, value: res.data._id };
      setOptions((prev) => [...prev, newOption]);
      setFieldValue(fieldName, newOption?.value ?? "");
      if (handleChange) {
        handleChange(newOption);
      }
    } catch (err) {
      console.error("Failed to create option:", err);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div
      className={`form-group ${classes ? classes : ""} mb-3 ${
        error ? "is-invalid" : "is-valid"
      }`}
    >
      <label className="text-label">{label}</label>
      {console.log("asdvasvdweadv3", options)}
      <CreatableSelect
        // isMulti
        isClearable
        isLoading={isLoading}
        onChange={(selected) => {
          setFieldValue(fieldName, selected?.value ?? "");
          if (handleChange) {
            handleChange(selected);
          }
        }}
        onBlur={() => setFieldValue(`touched.${fieldName}`, true)}
        name={fieldName}
        style={{
          lineHeight: "40px",
          color: "#7e7e7e",
          paddingLeft: " 15px",
        }}
        onInputChange={(value) => setInputValue(value)}
        onCreateOption={handleCreate}
        options={options}
        value={
          values
            ? {
                label: values.label,
                value: values.value,
              }
            : {}
        }
        placeholder="Select or Type something to create"
      />

      {error && (
        <div
          id={`val-${fieldName}-error`}
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default CustomCreatableDropdown;
